import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useInterval } from '@composables/useInterval'
    import { useUserActivity } from '@composables/useUserActivity'
    import { usePageReloaded } from '@composables/usePageReloaded'
    import { usePipelineTriggerPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PipelineTriggerPage',
  setup(__props) {

    document.title = "Pipeline trigger"

    const connectorProviderReadPage = ref(null);

    const tid = useOrganizationUnitId()
    const id = useId()
    const pageReloaded = usePageReloaded()
    const { isUserActive } = useUserActivity(20000)

    const { useCurrentUserQuery, usePipelineTriggerQuery, useLastRunsForPipelineByUserQuery, useTriggerPipelineManuallyCommand } = usePipelineTriggerPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineTriggerQueryV1, modelPipelineTriggerQueryV1 } = usePipelineTriggerQuery(id)
    const pipelineName = computed(() => modelPipelineTriggerQueryV1.value?.Name)
    const connectorId = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorId)
    const connectorIsReady = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorIsReady)
    const connectorStatus = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorStatus)
    const connectorProviderReadPageUrl = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorProviderReadPageUrl)

    const { modelLastRunsForPipelineByUserQueryV1, runLastRunsForPipelineByUserQueryV1 } = useLastRunsForPipelineByUserQuery(id, userId, false)
    const runs = computed(() => modelLastRunsForPipelineByUserQueryV1.value?.Runs ?? [])

    const { invokeTriggerPipelineManuallyCommandV1, succeedTriggerPipelineManuallyCommandV1 } = useTriggerPipelineManuallyCommand(id, tid, userId)

    useInterval(() => {
        if (isUserActive.value) {
            runPipelineTriggerQueryV1()
            runLastRunsForPipelineByUserQueryV1()
        }
    },
    5000)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineTriggerQueryV1()
    })

    watch(userId, () => userId.value && runLastRunsForPipelineByUserQueryV1())

return { __sfc: true,connectorProviderReadPage, tid, id, pageReloaded, isUserActive, useCurrentUserQuery, usePipelineTriggerQuery, useLastRunsForPipelineByUserQuery, useTriggerPipelineManuallyCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineTriggerQueryV1, modelPipelineTriggerQueryV1, pipelineName, connectorId, connectorIsReady, connectorStatus, connectorProviderReadPageUrl, modelLastRunsForPipelineByUserQueryV1, runLastRunsForPipelineByUserQueryV1, runs, invokeTriggerPipelineManuallyCommandV1, succeedTriggerPipelineManuallyCommandV1 }
}

})